var _path, _path2, _path3, _path4, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationHero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 658,
    height: 465,
    viewBox: "0 0 658 465",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_444)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M628.401 0H29.5986C13.2518 0 0 14.0594 0 31.4026V433.597C0 450.94 13.2518 465 29.5986 465H628.401C644.748 465 658 450.94 658 433.597V31.4026C658 14.0594 644.748 0 628.401 0Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M627.521 2.4165H30.7336C15.0155 2.4165 2.27344 15.9352 2.27344 32.6113V433.435C2.27344 450.111 15.0155 463.63 30.7336 463.63H627.521C643.239 463.63 655.981 450.111 655.981 433.435V32.6113C655.981 15.9352 643.239 2.4165 627.521 2.4165Z",
    fill: "url(#paint0_linear_81_444)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M592.316 23H67.684C64.545 23 62 25.6452 62 28.9081V435.092C62 438.356 64.545 441 67.684 441H592.316C595.455 441 598 438.356 598 435.092V28.9081C598 25.6452 595.455 23 592.316 23Z",
    fill: "#2A2A2A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_81_444",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 23,
    width: 612,
    height: 419
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M625.016 23.3125H33.0438C28.014 23.3125 23.9365 27.6385 23.9365 32.9749V431.546C23.9365 436.882 28.014 441.209 33.0438 441.209H625.016C630.047 441.209 634.123 436.882 634.123 431.546V32.9749C634.123 27.6385 630.047 23.3125 625.016 23.3125Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_81_444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M624.896 23H33.1045C28.0763 23 24 27.3892 24 32.8035V437.197C24 442.611 28.0763 447 33.1045 447H624.896C629.924 447 634 442.611 634 437.197V32.8035C634 27.3892 629.924 23 624.896 23Z",
    fill: "#E8EAF6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9219 23.5215H642.631V87.0924H19.9219V23.5215Z",
    fill: "#5267DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.245,
    d: "M67.734 73.0904C77.794 73.0904 85.949 65.372 85.949 55.8508C85.949 46.3297 77.794 38.6113 67.734 38.6113C57.6744 38.6113 49.5195 46.3297 49.5195 55.8508C49.5195 65.372 57.6744 73.0904 67.734 73.0904Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.104,
    d: "M592.541 73.0904C602.601 73.0904 610.755 65.372 610.755 55.8508C610.755 46.3297 602.601 38.6113 592.541 38.6113C582.481 38.6113 574.326 46.3297 574.326 55.8508C574.326 65.372 582.481 73.0904 592.541 73.0904Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M236.225 45.0762H106.446C104.56 45.0762 103.031 46.5233 103.031 48.3086C103.031 50.0939 104.56 51.541 106.446 51.541H236.225C238.111 51.541 239.64 50.0939 239.64 48.3086C239.64 46.5233 238.111 45.0762 236.225 45.0762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M172.474 60.1602H106.446C104.56 60.1602 103.031 61.6073 103.031 63.3926C103.031 65.1779 104.56 66.625 106.446 66.625H172.474C174.36 66.625 175.889 65.1779 175.889 63.3926C175.889 61.6073 174.36 60.1602 172.474 60.1602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.848 123.519H97.9381C92.9091 123.519 88.8311 127.378 88.8311 132.139V455.38C88.8311 460.14 92.9091 464 97.9381 464H376.848C381.879 464 385.955 460.14 385.955 455.38V132.139C385.955 127.378 381.879 123.519 376.848 123.519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.938 124H434.062C429.058 124 425 127.593 425 132.025V432.974C425 437.406 429.058 441 434.062 441H560.938C565.944 441 570 437.406 570 432.974V132.025C570 127.593 565.944 124 560.938 124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M311.358 164.676H181.579C179.693 164.676 178.164 166.123 178.164 167.909C178.164 169.694 179.693 171.141 181.579 171.141H311.358C313.244 171.141 314.773 169.694 314.773 167.909C314.773 166.123 313.244 164.676 311.358 164.676Z",
    fill: "#242A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.871 192.689C152.931 192.689 161.085 184.971 161.085 175.45C161.085 165.928 152.931 158.21 142.871 158.21C132.811 158.21 124.656 165.928 124.656 175.45C124.656 184.971 132.811 192.689 142.871 192.689Z",
    fill: "#F98E5D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M544.725 147.435H451.375C449.489 147.435 447.96 148.883 447.96 150.668C447.96 152.453 449.489 153.9 451.375 153.9H544.725C546.611 153.9 548.14 152.453 548.14 150.668C548.14 148.883 546.611 147.435 544.725 147.435Z",
    fill: "#242A45"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M544.725 168.985H451.375C449.489 168.985 447.96 170.432 447.96 172.217C447.96 174.002 449.489 175.449 451.375 175.449H544.725C546.611 175.449 548.14 174.002 548.14 172.217C548.14 170.432 546.611 168.985 544.725 168.985Z",
    fill: "#242A45"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M544.725 190.534H451.375C449.489 190.534 447.96 191.981 447.96 193.766C447.96 195.552 449.489 196.999 451.375 196.999H544.725C546.611 196.999 548.14 195.552 548.14 193.766C548.14 191.981 546.611 190.534 544.725 190.534Z",
    fill: "#242A45"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M544.725 212.085H451.375C449.489 212.085 447.96 213.532 447.96 215.317C447.96 217.103 449.489 218.55 451.375 218.55H544.725C546.611 218.55 548.14 217.103 548.14 215.317C548.14 213.532 546.611 212.085 544.725 212.085Z",
    fill: "#242A45"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M544.725 248.718H451.375C449.489 248.718 447.96 250.165 447.96 251.95C447.96 253.736 449.489 255.183 451.375 255.183H544.725C546.611 255.183 548.14 253.736 548.14 251.95C548.14 250.165 546.611 248.718 544.725 248.718Z",
    fill: "#242A45"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M544.725 270.267H451.375C449.489 270.267 447.96 271.714 447.96 273.5C447.96 275.285 449.489 276.732 451.375 276.732H544.725C546.611 276.732 548.14 275.285 548.14 273.5C548.14 271.714 546.611 270.267 544.725 270.267Z",
    fill: "#242A45"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M544.725 291.817H451.375C449.489 291.817 447.96 293.264 447.96 295.049C447.96 296.834 449.489 298.281 451.375 298.281H544.725C546.611 298.281 548.14 296.834 548.14 295.049C548.14 293.264 546.611 291.817 544.725 291.817Z",
    fill: "#242A45"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M247.607 179.759H181.579C179.693 179.759 178.164 181.206 178.164 182.991C178.164 184.777 179.693 186.224 181.579 186.224H247.607C249.493 186.224 251.022 184.777 251.022 182.991C251.022 181.206 249.493 179.759 247.607 179.759Z",
    fill: "#242A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.871 253.028C152.931 253.028 161.085 245.311 161.085 235.788C161.085 226.267 152.931 218.549 142.871 218.549C132.811 218.549 124.656 226.267 124.656 235.788C124.656 245.311 132.811 253.028 142.871 253.028Z",
    fill: "#6AC6D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M311.358 225.014H181.579C179.693 225.014 178.164 226.461 178.164 228.247C178.164 230.032 179.693 231.479 181.579 231.479H311.358C313.244 231.479 314.773 230.032 314.773 228.247C314.773 226.461 313.244 225.014 311.358 225.014Z",
    fill: "#242A45"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M247.607 240.097H181.579C179.693 240.097 178.164 241.544 178.164 243.33C178.164 245.115 179.693 246.562 181.579 246.562H247.607C249.493 246.562 251.022 245.115 251.022 243.33C251.022 241.544 249.493 240.097 247.607 240.097Z",
    fill: "#242A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.871 313.366C152.931 313.366 161.085 305.648 161.085 296.126C161.085 286.605 152.931 278.886 142.871 278.886C132.811 278.886 124.656 286.605 124.656 296.126C124.656 305.648 132.811 313.366 142.871 313.366Z",
    fill: "#A47ED4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M311.358 285.353H181.579C179.693 285.353 178.164 286.8 178.164 288.586C178.164 290.371 179.693 291.818 181.579 291.818H311.358C313.244 291.818 314.773 290.371 314.773 288.586C314.773 286.8 313.244 285.353 311.358 285.353Z",
    fill: "#242A45"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M247.607 300.437H181.579C179.693 300.437 178.164 301.884 178.164 303.669C178.164 305.455 179.693 306.902 181.579 306.902H247.607C249.493 306.902 251.022 305.455 251.022 303.669C251.022 301.884 249.493 300.437 247.607 300.437Z",
    fill: "#242A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.871 373.707C152.931 373.707 161.085 365.989 161.085 356.467C161.085 346.946 152.931 339.227 142.871 339.227C132.811 339.227 124.656 346.946 124.656 356.467C124.656 365.989 132.811 373.707 142.871 373.707Z",
    fill: "#EC7878"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M311.358 345.691H181.579C179.693 345.691 178.164 347.138 178.164 348.923C178.164 350.708 179.693 352.155 181.579 352.155H311.358C313.244 352.155 314.773 350.708 314.773 348.923C314.773 347.138 313.244 345.691 311.358 345.691Z",
    fill: "#242A45"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M247.607 360.775H181.579C179.693 360.775 178.164 362.222 178.164 364.007C178.164 365.793 179.693 367.24 181.579 367.24H247.607C249.493 367.24 251.022 365.793 251.022 364.007C251.022 362.222 249.493 360.775 247.607 360.775Z",
    fill: "#242A45"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_81_444",
    x1: 649.529,
    y1: 332.991,
    x2: 108.236,
    y2: -6.28888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3D3D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 658,
    height: 465,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationHero);
export default __webpack_public_path__ + "static/media/illustration-hero.b0c376af1874c8ca5bce6475e675b093.svg";
export { ForwardRef as ReactComponent };